import React, { Component } from 'react';


class SliderOne extends Component {
	render() {

		return (
			<div className="ttr-slider style-2">
				<div className="ttr-swiper01">
					<div className="slider-item">
						<div className="slider-img pocetna">

						</div>
						<div className="slider-content container text-center text-white">
							<div className="content-inner">
								{/* <h6 className="sub-title title-shadow">Dobrodošli</h6> */}
								<h2 className="title title-shadow">Major Mob Servis</h2>
							</div>
						</div>
					</div>

				</div>
			</div>
		);
	}
}

export default SliderOne;